export const RegistrationStatus = {
    PENDING: "PENDING",
    VALIDATED: "VALIDATED",
    CANCELLED: "CANCELLED",
};